/**
 * Open eye symbol — "show overlay" indicator.
 * Uses `currentColor`.
 */
export function ShowOverlay({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 39 26"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0175 19.131C6.23185 17.1125 3.93141 14.7293 2.51662 12.9692C3.93141 11.2091 6.23185 8.82598 9.0175 6.80739C12.148 4.53891 15.7751 2.8147 19.3761 2.8147C22.9771 2.8147 26.6042 4.53891 29.7347 6.80739C32.5203 8.82598 34.8208 11.2091 36.2356 12.9692C34.8208 14.7293 32.5203 17.1125 29.7347 19.131C26.6042 21.3995 22.9771 23.1237 19.3761 23.1237C15.7751 23.1237 12.148 21.3995 9.0175 19.131ZM19.3761 0.814697C15.1689 0.814697 11.1273 2.80866 7.84395 5.18789C4.54711 7.57691 1.89765 10.439 0.45 12.3692L0 12.9692L0.45 13.5692C1.89765 15.4994 4.54711 18.3615 7.84395 20.7505C11.1273 23.1298 15.1689 25.1237 19.3761 25.1237C23.5833 25.1237 27.6249 23.1298 30.9082 20.7505C34.2051 18.3615 36.8545 15.4994 38.3022 13.5692L38.7522 12.9692L38.3022 12.3692C36.8545 10.439 34.2051 7.57691 30.9082 5.18789C27.6249 2.80866 23.5833 0.814697 19.3761 0.814697ZM24.3477 12.9691C24.3477 15.7148 22.1218 17.9407 19.3761 17.9407C16.6304 17.9407 14.4045 15.7148 14.4045 12.9691C14.4045 10.2233 16.6304 7.9975 19.3761 7.9975C22.1218 7.9975 24.3477 10.2233 24.3477 12.9691ZM26.3477 12.9691C26.3477 16.8194 23.2264 19.9407 19.3761 19.9407C15.5258 19.9407 12.4045 16.8194 12.4045 12.9691C12.4045 9.11878 15.5258 5.9975 19.3761 5.9975C23.2264 5.9975 26.3477 9.11878 26.3477 12.9691Z"
      />
    </svg>
  )
}
